import { createApiAction } from 'src/api';

export const FETCH_FIS_START = 'fis/fetch_fis_start';
export const FETCH_FIS_SUCCESS = 'fis/fetch_fis_success';
export const FETCH_FIS_FAILURE = 'fis/fetch_fis_failure';

export const ADD_FI_START = 'fis/add_fi_start';
export const ADD_FI_SUCCESS = 'fis/add_fi_success';
export const ADD_FI_FAILURE = 'fis/add_fi_failure';

export const UPDATE_FI_START = 'fis/update_fi_start';
export const UPDATE_FI_SUCCESS = 'fis/update_fi_success';
export const UPDATE_FI_FAILURE = 'fis/update_fi_failure';

export const DELETE_FI_START = 'fis/delete_fi_start';
export const DELETE_FI_SUCCESS = 'fis/delete_fi_success';
export const DELETE_FI_FAILURE = 'fis/delete_fi_failure';

export const FETCH_FI_SETTINGS_START = 'fis/fetch_fi_settings_start';
export const FETCH_FI_SETTINGS_SUCCESS = 'fis/fetch_fi_settings_success';
export const FETCH_FI_SETTINGS_FAILURE = 'fis/fetch_fi_settings_failure';

export const UPDATE_FI_SETTINGS_START = 'fis/update_fi_settings_start';
export const UPDATE_FI_SETTINGS_SUCCESS = 'fis/update_fi_settings_success';
export const UPDATE_FI_SETTINGS_FAILURE = 'fis/update_fi_settings_failure';

export const FETCH_FI_PEOPLE_START = 'fis/fetch_fi_people_start';
export const FETCH_FI_PEOPLE_SUCCESS = 'fis/fetch_fi_people_success';
export const FETCH_FI_PEOPLE_FAILURE = 'fis/fetch_fi_people_failure';

export const ADD_FI_PERSON_START = 'fis/add_fi_user_start';
export const ADD_FI_PERSON_SUCCESS = 'fis/add_fi_user_success';
export const ADD_FI_PERSON_FAILURE = 'fis/add_fi_user_failure';

export const UPDATE_FI_PERSON_START = 'fis/update_fi_user_start';
export const UPDATE_FI_PERSON_SUCCESS = 'fis/update_fi_user_success';
export const UPDATE_FI_PERSON_FAILURE = 'fis/update_fi_user_failure';

export const DELETE_FI_PERSON_START = 'fis/delete_fi_user_start';
export const DELETE_FI_PERSON_SUCCESS = 'fis/delete_fi_user_success';
export const DELETE_FI_PERSON_FAILURE = 'fis/delete_fi_user_failure';

export const FETCH_FI_DOCUMENT_TYPES_START = 'fis/fetch_document_type_start';
export const FETCH_FI_DOCUMENT_TYPES_SUCCESS =
  'fis/fetch_document_type_success';
export const FETCH_FI_DOCUMENT_TYPES_FAILURE =
  'fis/fetch_document_type_failure';

export const ADD_FI_DOCUMENT_TYPE_START = 'fis/add_document_type_start';
export const ADD_FI_DOCUMENT_TYPE_SUCCESS = 'fis/add_document_type_success';
export const ADD_FI_DOCUMENT_TYPE_FAILURE = 'fis/add_document_type_failure';

export const UPDATE_FI_DOCUMENT_TYPE_START = 'fis/update_document_type_start';
export const UPDATE_FI_DOCUMENT_TYPE_SUCCESS =
  'fis/update_document_type_success';
export const UPDATE_FI_DOCUMENT_TYPE_FAILURE =
  'fis/update_document_type_failure';

export const DELETE_FI_DOCUMENT_TYPE_START = 'fis/delete_document_type_start';
export const DELETE_FI_DOCUMENT_TYPE_SUCCESS =
  'fis/delete_document_type_success';
export const DELETE_FI_DOCUMENT_TYPE_FAILURE =
  'fis/delete_document_type_failure';

export const FETCH_FI_CONSENT_TYPES_START = 'fis/fetch_consent_type_start';
export const FETCH_FI_CONSENT_TYPES_SUCCESS = 'fis/fetch_consent_type_success';
export const FETCH_FI_CONSENT_TYPES_FAILURE = 'fis/fetch_consent_type_failure';

export const ADD_FI_CONSENT_TYPE_START = 'fis/add_consent_type_start';
export const ADD_FI_CONSENT_TYPE_SUCCESS = 'fis/add_consent_type_success';
export const ADD_FI_CONSENT_TYPE_FAILURE = 'fis/add_consent_type_failure';

export const UPDATE_FI_CONSENT_TYPE_START = 'fis/update_consent_type_start';
export const UPDATE_FI_CONSENT_TYPE_SUCCESS = 'fis/update_consent_type_success';
export const UPDATE_FI_CONSENT_TYPE_FAILURE = 'fis/update_consent_type_failure';

export const DELETE_FI_CONSENT_TYPE_START = 'fis/delete_consent_type_start';
export const DELETE_FI_CONSENT_TYPE_SUCCESS = 'fis/delete_consent_type_success';
export const DELETE_FI_CONSENT_TYPE_FAILURE = 'fis/delete_consent_type_failure';

export const fetchFIs = () => {
  return createApiAction(
    {
      path: `/api/v1/fis/`,
    },
    [FETCH_FIS_START, FETCH_FIS_SUCCESS, FETCH_FIS_FAILURE]
  );
};

const buildFormData = ({
  businessName,
  institutionType,
  logo,
  logoSmall,
  logoBlue,
  logoMail,
  supportName,
  supportPhone,
  allowsBanking,
  allowsPayments,
  allowsLending,
  ndaTemplateId,
  backgroundCheckConsent,
  personFirstName,
  personLastName,
  personPrimaryNumber,
  personEmailAddress,
}) => {
  const formData = new FormData();
  if (businessName) {
    formData.append('financial_institution_business_name', businessName);
  }

  if (institutionType) {
    formData.append('financial_institution_type', institutionType);
  }

  if (logo) {
    formData.append('financial_institution_logo', logo);
  }

  if (logoSmall) {
    formData.append('financial_institution_logo_small', logoSmall);
  }

  if (logoBlue) {
    formData.append('financial_institution_logo_blue', logoBlue);
  }

  if (logoMail) {
    formData.append('financial_institution_logo_email', logoMail);
  }

  if (supportName) {
    formData.append('financial_institution_support_name', supportName);
  }

  if (supportPhone) {
    formData.append('financial_institution_support_phone', supportPhone);
  }

  if (allowsBanking) {
    formData.append('financial_institution_allows_banking', allowsBanking);
  }

  if (allowsPayments) {
    formData.append('financial_institution_allows_payments', allowsPayments);
  }

  if (allowsLending) {
    formData.append('financial_institution_allows_lending', allowsLending);
  }

  if (ndaTemplateId) {
    formData.append('financial_institution_nda_template_id', ndaTemplateId);
  }

  if (personFirstName) {
    formData.append('user_first_name', personFirstName);
  }

  if (personLastName) {
    formData.append('user_last_name', personLastName);
  }

  if (personPrimaryNumber) {
    formData.append('user_primary_number', personPrimaryNumber);
  }

  if (personEmailAddress) {
    formData.append('user_email_address', personEmailAddress);
  }

  if (backgroundCheckConsent) {
    formData.append(
      'financial_institution_background_check_consent',
      backgroundCheckConsent
    );
  }

  return formData;
};

export const addFI = fi => {
  return createApiAction(
    {
      path: `/api/v1/fis/`,
      method: 'POST',
      formData: buildFormData(fi),
    },
    [ADD_FI_START, ADD_FI_SUCCESS, ADD_FI_FAILURE]
  );
};

export const updateFI = fi => {
  const formData = buildFormData(fi);

  return createApiAction(
    {
      path: `/api/v1/fis/${fi.financialInstitutionId}/`,
      method: 'PUT',
      formData,
    },
    [UPDATE_FI_START, UPDATE_FI_SUCCESS, UPDATE_FI_FAILURE]
  );
};

export const deleteFI = financialInstitutionId =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/`,
      method: 'DELETE',
    },
    [DELETE_FI_START, DELETE_FI_SUCCESS, DELETE_FI_FAILURE]
  );

/* FI Settings */

export const fetchFISettings = fi =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/fi_settings`,
      method: 'GET',
    },
    [
      FETCH_FI_SETTINGS_START,
      FETCH_FI_SETTINGS_SUCCESS,
      FETCH_FI_SETTINGS_FAILURE,
    ]
  );

export const updateFISettings = ({
  fi,
  fiDbaName,
  fiRestrictedWords,
  fiMediaCheckEmails,
  fiTin,
  fiPhoneNumber,
  fiEmailAddress,
  fiWebsite,
  fiRegisteredState,
  fiSupportName,
  fiSupportTitle,
  fiSupportEmail,
  fiSupportPhone,
  fiPrimaryAddress,
  fiPrimaryAddress2,
  fiPrimaryCity,
  fiPrimaryState,
  fiPrimaryZipcode,
  fiMailingAddress,
  fiMailingAddress2,
  fiMailingCity,
  fiMailingState,
  fiMailingZipcode,
  fiSarContactOffice,
  fiSarContactPhone,
  fiFilingInstitutionId,
  fiFilingInstitutionType,
  fiFilingInstitutionIdType,
  fiPrimaryFederalRegulator,
  fiInviteEmail,
  fiPaymentAccountInvite,
  fiAdminInvite,
  fiPaymentAccountPersonInvite,
  fiAssignAdminsToAccounts,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/fi_settings/`,
      method: 'PUT',
      body: {
        financial_institution_dba_name: fiDbaName,
        financial_institution_restricted_words: fiRestrictedWords,
        financial_institution_media_check_emails: fiMediaCheckEmails,
        financial_institution_tin: fiTin,
        financial_institution_phone_number: fiPhoneNumber,
        financial_institution_email_address: fiEmailAddress,
        financial_institution_website: fiWebsite,
        financial_institution_registered_state: fiRegisteredState
          ? fiRegisteredState.value
          : null,
        financial_institution_support_name: fiSupportName,
        financial_institution_support_title: fiSupportTitle,
        financial_institution_support_email: fiSupportEmail,
        financial_institution_support_phone: fiSupportPhone,
        financial_institution_primary_address: fiPrimaryAddress,
        financial_institution_primary_address_2: fiPrimaryAddress2,
        financial_institution_primary_city: fiPrimaryCity,
        financial_institution_primary_state: fiPrimaryState,
        financial_institution_primary_zipcode: fiPrimaryZipcode,
        financial_institution_mailing_address: fiMailingAddress,
        financial_institution_mailing_address_2: fiMailingAddress2,
        financial_institution_mailing_city: fiMailingCity,
        financial_institution_mailing_state: fiMailingState,
        financial_institution_mailing_zipcode: fiMailingZipcode,
        financial_institution_sar_contact_office: fiSarContactOffice,
        financial_institution_sar_contact_phone: fiSarContactPhone,
        financial_institution_filing_institution_id: fiFilingInstitutionId,
        financial_institution_filing_institution_type: fiFilingInstitutionType,
        financial_institution_filing_institution_identification_type: fiFilingInstitutionIdType,
        financial_institution_primary_federal_regulator: fiPrimaryFederalRegulator,
        financial_institution_invite_email: fiInviteEmail,
        financial_institution_payment_account_invite: fiPaymentAccountInvite,
        financial_institution_fi_admin_invite: fiAdminInvite,
        financial_institution_payment_account_person_invite: fiPaymentAccountPersonInvite,
        financial_institution_assign_admins_to_accounts: fiAssignAdminsToAccounts,
      },
    },
    [
      UPDATE_FI_SETTINGS_START,
      UPDATE_FI_SETTINGS_SUCCESS,
      UPDATE_FI_SETTINGS_FAILURE,
    ]
  );

/* people */

export const fetchFIPeople = ({ financialInstitutionId }) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/users/`,
      method: 'GET',
    },
    [FETCH_FI_PEOPLE_START, FETCH_FI_PEOPLE_SUCCESS, FETCH_FI_PEOPLE_FAILURE]
  );

export const addFIPerson = ({
  financialInstitutionId,
  emailAddress,
  firstName,
  lastName,
  type,
  roleId,
  primaryNumber,
  isAdmin,
  isSigner,
  sendEmail,
  message,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/users/`,
      method: 'POST',
      body: {
        user_financial_institution_id: financialInstitutionId,
        user_type: type,
        user_first_name: firstName,
        user_last_name: lastName,
        user_primary_number: primaryNumber,
        user_email_address: emailAddress,
        user_is_admin: !!isAdmin,
        user_is_signer: !!isSigner,
        send_email: !!sendEmail,
        user_role: roleId,
        message,
      },
    },
    [ADD_FI_PERSON_START, ADD_FI_PERSON_SUCCESS, ADD_FI_PERSON_FAILURE]
  );

export const updateFIPerson = ({
  financialInstitutionId,
  personId,
  firstName,
  lastName,
  emailAddress,
  primaryNumber,
  roleId,
  expirationNotificationFrequency,
  receiveExpirationNotification,
  notifyOnDocumentUpload,
  complianceAlertIsActive,
  complianceAlertNotifyFailed,
  complianceAlertNotifyPassed,
  complianceAlertNotifyReview,
  complianceAlertFrequency,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/users/${personId}/`,
      method: 'PUT',
      body: {
        user_first_name: firstName,
        user_last_name: lastName,
        user_email_address: emailAddress,
        user_primary_number: primaryNumber,
        user_compliance_alert_email: complianceAlertFrequency
          ? {
              compliance_alert_email_is_active: complianceAlertIsActive,
              compliance_alert_email_notify_passed: complianceAlertNotifyPassed,
              compliance_alert_email_notify_failed: complianceAlertNotifyFailed,
              compliance_alert_email_notify_review: complianceAlertNotifyReview,
              compliance_alert_email_frequency: complianceAlertFrequency,
            }
          : {},
        user_financial_institution: {
          user_financial_institution_role: roleId,
          user_financial_institution_user: personId,
          user_financial_institution_financial_institution: financialInstitutionId,
          user_financial_institution_receive_expiration_notifications: receiveExpirationNotification,
          user_financial_institution_expiration_notification_frequency: expirationNotificationFrequency,
          user_financial_institution_notify_on_document_upload: notifyOnDocumentUpload,
        },
      },
    },
    [UPDATE_FI_PERSON_START, UPDATE_FI_PERSON_SUCCESS, UPDATE_FI_PERSON_FAILURE]
  );

export const deleteFIPerson = ({ financialInstitutionId, personId }) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/users/${personId}/`,
      method: 'DELETE',
    },
    [DELETE_FI_PERSON_START, DELETE_FI_PERSON_SUCCESS, DELETE_FI_PERSON_FAILURE]
  );
};

// DOCUMENT TYPES

export const fetchFIDocumentTypes = financialInstitutionId => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/document_types/`,
      method: 'GET',
    },
    [
      FETCH_FI_DOCUMENT_TYPES_START,
      FETCH_FI_DOCUMENT_TYPES_SUCCESS,
      FETCH_FI_DOCUMENT_TYPES_FAILURE,
    ]
  );
};

export const addFIDocumentType = ({
  financialInstitutionId,
  name,
  description,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/document_types/`,
      method: 'POST',
      body: {
        document_type_type: name,
        document_type_description: description,
      },
    },
    [
      ADD_FI_DOCUMENT_TYPE_START,
      ADD_FI_DOCUMENT_TYPE_SUCCESS,
      ADD_FI_DOCUMENT_TYPE_FAILURE,
    ]
  );
};

export const updateFIDocumentType = ({
  financialInstitutionId,
  documentTypeId,
  name,
  description,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/document_types/${documentTypeId}/`,
      method: 'PUT',
      body: {
        document_type_type: name,
        document_type_description: description,
      },
    },
    [
      UPDATE_FI_DOCUMENT_TYPE_START,
      UPDATE_FI_DOCUMENT_TYPE_SUCCESS,
      UPDATE_FI_DOCUMENT_TYPE_FAILURE,
    ]
  );
};

export const deleteFIDocumentType = ({
  financialInstitutionId,
  documentTypeId,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/document_types/${documentTypeId}/`,
      method: 'DELETE',
    },
    [
      DELETE_FI_DOCUMENT_TYPE_START,
      DELETE_FI_DOCUMENT_TYPE_SUCCESS,
      DELETE_FI_DOCUMENT_TYPE_FAILURE,
    ]
  );
};

// CONSENT TYPES

export const fetchFIConsentTypes = financialInstitutionId => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/consent_types/`,
      method: 'GET',
    },
    [
      FETCH_FI_CONSENT_TYPES_START,
      FETCH_FI_CONSENT_TYPES_SUCCESS,
      FETCH_FI_CONSENT_TYPES_FAILURE,
    ]
  );
};

export const addFIConsentType = ({
  financialInstitutionId,
  name,
  longDescription,
  shortDescription,
  isBackgroundCheck,
  isSolventBackgroundCheck,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/consent_types/`,
      method: 'POST',
      body: {
        consent_type_type: name,
        consent_type_long_description: longDescription,
        consent_type_short_description: shortDescription,
        consent_type_is_background_check: isBackgroundCheck,
        consent_type_is_solvent_background_check: isSolventBackgroundCheck,
      },
    },
    [
      ADD_FI_CONSENT_TYPE_START,
      ADD_FI_CONSENT_TYPE_SUCCESS,
      ADD_FI_CONSENT_TYPE_FAILURE,
    ]
  );
};

export const updateFIConsentType = ({
  financialInstitutionId,
  consentTypeId,
  name,
  longDescription,
  shortDescription,
  isBackgroundCheck,
  isSolventBackgroundCheck,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/consent_types/${consentTypeId}/`,
      method: 'PUT',
      body: {
        consent_type_type: name,
        consent_type_long_description: longDescription,
        consent_type_short_description: shortDescription,
        consent_type_is_background_check: isBackgroundCheck,
        consent_type_is_solvent_background_check: isSolventBackgroundCheck,
      },
    },
    [
      UPDATE_FI_CONSENT_TYPE_START,
      UPDATE_FI_CONSENT_TYPE_SUCCESS,
      UPDATE_FI_CONSENT_TYPE_FAILURE,
    ]
  );
};

export const deleteFIConsentType = ({
  financialInstitutionId,
  consentTypeId,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/consent_types/${consentTypeId}/`,
      method: 'DELETE',
    },
    [
      DELETE_FI_CONSENT_TYPE_START,
      DELETE_FI_CONSENT_TYPE_SUCCESS,
      DELETE_FI_CONSENT_TYPE_FAILURE,
    ]
  );
};
